export var NavController = {
    init: function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.initChooseCountryMenu();
                _this.initMobileMenu();
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    },
    initChooseCountryMenu: function () {
        var header = document.querySelector('header');
        var choose_country_button = document.querySelector('.choose-country__button');
        var inner = document.querySelector('.choose-country-container');
        var logo = document.querySelector('.hold-logo__container');
        // Toggle for chooseCountryMenu
        choose_country_button === null || choose_country_button === void 0 ? void 0 : choose_country_button.addEventListener('click', function (e) {
            e.stopPropagation();
            if (header && inner && choose_country_button) {
                inner.classList.toggle('open');
                choose_country_button.classList.toggle('button__active');
                if (inner.classList.contains('open')) {
                    logo === null || logo === void 0 ? void 0 : logo.classList.add('hide');
                }
                else {
                    logo === null || logo === void 0 ? void 0 : logo.classList.remove('hide');
                }
            }
        });
        // Close chooseCountryMenu when click outside
        document.addEventListener('click', function (e) {
            var target = e.target;
            if ((inner === null || inner === void 0 ? void 0 : inner.classList.contains('open')) &&
                target instanceof Node &&
                !inner.contains(target) &&
                !(choose_country_button === null || choose_country_button === void 0 ? void 0 : choose_country_button.contains(target))) {
                inner.classList.remove('open');
                choose_country_button === null || choose_country_button === void 0 ? void 0 : choose_country_button.classList.remove('button__active');
                logo === null || logo === void 0 ? void 0 : logo.classList.remove('hide');
            }
        });
    },
    initMobileMenu: function () {
        var nav = document.querySelector('.nav');
        var menu = document.querySelector('.nav-menu');
        var hamburguer = document.querySelector('.hamburguer-icon');
        var body = document.body;
        if (hamburguer) {
            hamburguer.addEventListener('click', function () {
                hamburguer.classList.toggle('open');
            });
        }
        if (hamburguer && nav && menu) {
            hamburguer.addEventListener('click', function () {
                nav.classList.toggle('active');
                menu.classList.toggle('active');
                body.style.overflow = body.style.overflow === 'hidden' ? '' : 'hidden';
            });
        }
        window.addEventListener('resize', function () {
            if (window.innerWidth > 768) {
                nav === null || nav === void 0 ? void 0 : nav.classList.remove('active');
                menu === null || menu === void 0 ? void 0 : menu.classList.remove('active');
                hamburguer === null || hamburguer === void 0 ? void 0 : hamburguer.classList.remove('open');
                body.style.overflow = '';
            }
        });
    },
};
